import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch, useHistory, useLocation } from 'react-router-dom';

import { Avatar, Box, Button, CardMedia, Typography } from '@material-ui/core';

import filter_1 from 'assets/icons/presencial.png';
import filter_2 from 'assets/icons/online.png';
import filter_3 from 'assets/icons/domicilio.png';

import { setNutritionist } from 'redux/slices/nutritionist.slice';
import { setModalStatus } from 'redux/slices/modal.slice';
import {
  baseLinkRequestsSelector,
  userSelector,
} from 'features/user/selectors/user.selector';

import { useStyles } from './nutritionist-card.styles';

export const NutritionistCard = ({ nutritionist }) => {
  const [services] = useState({
    onsite: filter_1,
    online: filter_2,
    home: filter_3,
  });

  const [modes, setModes] = useState([]);

  const { isAuthenticated } = useSelector(state => state.authentication);
  const linkRequests = useSelector(baseLinkRequestsSelector);

  const wnUser = useSelector(userSelector);

  const { url } = useRouteMatch();
  const { push } = useHistory();
  const { search } = useLocation();

  const classes = useStyles();

  const dispatch = useDispatch();

  const nutritionistId = nutritionist._id;
  const nutritionistProfile = nutritionist.nutritionistProfile;
  const nutritionistName = `${nutritionist.name} ${nutritionist.lastName}`;
  const nutritionistInitials = nutritionist.name[0] + nutritionist.lastName[0];

  const onGetInTouchHandler = () => {
    if (isAuthenticated) {
      const isLinkedAlready =
        wnUser.patientProfile.nutritionist === nutritionistId;
      const isPendingToLink = linkRequests.some(
        linkRequest =>
          linkRequest.nutritionistContact.nutritionist === nutritionistId,
      );

      if (isPendingToLink || isLinkedAlready) {
        dispatch(
          setModalStatus({
            name: 'LINK_REQUEST_WARNING',
            isActive: true,
          }),
        );
        return;
      }
    }
    const online = nutritionistProfile.services.filter(service =>
      service.mode.includes('online'),
    );
    const onsite = nutritionistProfile.services.filter(service =>
      service.mode.includes('onsite'),
    );
    const home = nutritionistProfile.services.filter(service =>
      service.mode.includes('home'),
    );
    dispatch(
      setNutritionist({
        _id: nutritionistId,
        name: nutritionist.name,
        services: {
          online,
          onsite,
          home,
        },
      }),
    );

    if (isAuthenticated) {
      push(`${url}/contact/link-request/${nutritionistId}`);
    } else {
      dispatch(
        setModalStatus({
          name: 'SPECIAL_SIGN_IN',
          isActive: true,
        }),
      );
    }
  };

  const onOpenProfileHandler = () => {
    const format = nutritionist.name.toLowerCase().replace(' ', '-');
    push({
      pathname: `${url}/${format}/${nutritionistId}`,
      search,
    });
  };

  useEffect(() => {
    const sum = nutritionistProfile.services.reduce((accumulator, service) => {
      return [...accumulator, ...service.mode];
    }, []);
    const modes = [...new Set(sum)];
    setModes(modes);
  }, []);

  return (
    <Box component="aside" className={classes.card}>
      <Box component="header" mb={1}>
        <Box className={classes.wrapper}>
          <Typography
            variant="h6"
            component="h1"
            className={classes.name}
            onClick={onOpenProfileHandler}
          >
            {nutritionistName}
          </Typography>
          <Box component="ul" className={classes.flex}>
            {modes.map((mode, index) => (
              <CardMedia
                key={`${mode}-${index}`}
                component="img"
                image={services[mode]}
                className={classes.service}
              />
            ))}
          </Box>
        </Box>
        <Typography variant="body2" className={classes.ellipsis}>
          {nutritionistProfile.mainDegree || 'Titulo universitario'}
        </Typography>
      </Box>
      <Box component="main" mb={1} className={classes.flex}>
        <Avatar
          className={classes.avatar}
          src={nutritionist.pictureUrl}
          onClick={onOpenProfileHandler}
        >
          {nutritionistInitials}
        </Avatar>
        <Box ml={4} className={classes.start}>
          <Typography variant="body2">Especialidades:</Typography>
          <ul className={classes.specs}>
            {nutritionistProfile.specialities.map(spec => (
              <li key={spec._id}>
                <Typography variant="body2">{spec.name}</Typography>
              </li>
            ))}
          </ul>
        </Box>
      </Box>
      <Box component="footer" textAlign="right">
        <Button
          size="small"
          variant="text"
          onClick={onOpenProfileHandler}
          className={classes.mr}
          color="secondary"
        >
          Ver mas información
        </Button>
        <Button size="small" variant="contained" onClick={onGetInTouchHandler}>
          Contactar
        </Button>
      </Box>
    </Box>
  );
};
